import { useFormikContext } from 'formik';

import { withErrorBoundary } from 'components/shared/Error/Boundary';

import AccountAddress from './AccountAddress';
import AccountImage from './AccountImage';
import ContactInformation from './ContactInformation';
import DBAName from './DBAName';
import SelfScheduling from './SelfScheduling';
import StickyNotes from './StickyNotes';
import Technology from './Technology';
import ConsentModal from './TechnologyConsent/ConsentModal';
import TransactionBatchTimeWrapper from './TransactionBatchTimeWrapper';

const AccountForm = ({
  practice,
  setPractice,
  isServicesAvailable,
  addressRef,
  setShowTechnologyModal,
  selectedSurchargeButton,
  showCurrencyInput,
  setShowCurrencyInput,
  setSelectedSurchargeButton,
  showTechnologyModal
}) => {
  const surchargeOptions = [1, 2, 3, 4, 'Custom'];
  const { setFieldValue } = useFormikContext();

  return (
    <div className="flex h-full flex-col overflow-y-auto p-6">
      <AccountImage practice={practice} setPractice={setPractice} />
      <SelfScheduling practice={practice} isServicesAvailable={isServicesAvailable} />
      <DBAName practice={practice} setPractice={setPractice} />
      <ContactInformation practice={practice} />
      <AccountAddress ref={addressRef} practice={practice} />
      <Technology
        practice={practice}
        setShowTechnologyModal={setShowTechnologyModal}
        surchargeOptions={surchargeOptions}
        selectedSurchargeButton={selectedSurchargeButton}
        showCurrencyInput={showCurrencyInput}
        setShowCurrencyInput={setShowCurrencyInput}
        setSelectedSurchargeButton={setSelectedSurchargeButton}
      />
      <StickyNotes practice={practice} setPractice={setPractice} />
      <ConsentModal
        showTechnologyModal={showTechnologyModal}
        hideTechnologyModal={() => setShowTechnologyModal(false)}
        setPractice={setPractice}
        practice={practice}
        updateSurcharge={() => {
          setFieldValue('surchargeEnabled', true);
        }}
      />

      <TransactionBatchTimeWrapper practice={practice} setPractice={setPractice} />
    </div>
  );
};

export default withErrorBoundary(AccountForm);
